import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "mt-2",
    "data-test": "message-attachment-preview"
};
const _hoisted_2 = ["href"];
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = ["src"];
const _hoisted_5 = ["href"];
const _hoisted_6 = { class: "min-w-0 flex-1" };
const _hoisted_7 = { class: "block truncate font-medium" };
const _hoisted_8 = { class: "block opacity-75" };
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { IconExternalLink, IconFileText, IconFileTypePdf, } from "@tabler/icons-vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'MessageAttachmentPreview',
    props: {
        url: {},
        name: {},
        mimeType: {},
        size: {},
        isOutgoing: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const { t } = useI18n();
        const mimeType = computed(() => props.mimeType?.toLowerCase() ?? "");
        const url = computed(() => props.url ?? "");
        const fileName = computed(() => props.name || t("conversation.attachment.fallback_name"));
        const inlineImageMimeTypes = new Set([
            "image/jpeg",
            "image/png",
            "image/gif",
            "image/webp",
        ]);
        const inlineVideoMimeTypes = new Set([
            "video/mp4",
            "video/webm",
            "video/quicktime",
        ]);
        const sizeInBytes = computed(() => {
            if (props.size === null || props.size === undefined || props.size === "") {
                return null;
            }
            const value = Number(props.size);
            return Number.isFinite(value) ? value : null;
        });
        const isImage = computed(() => inlineImageMimeTypes.has(mimeType.value));
        const isVideo = computed(() => inlineVideoMimeTypes.has(mimeType.value));
        const isPdf = computed(() => mimeType.value === "application/pdf");
        const typeLabel = computed(() => {
            if (isPdf.value)
                return t("conversation.attachment.pdf");
            if (mimeType.value.includes("word"))
                return t("conversation.attachment.document");
            if (mimeType.value.includes("excel") || mimeType.value.includes("spreadsheet")) {
                return t("conversation.attachment.spreadsheet");
            }
            return t("conversation.attachment.file");
        });
        const sizeLabel = computed(() => {
            if (sizeInBytes.value === null)
                return "";
            const units = ["B", "KB", "MB", "GB"];
            let value = sizeInBytes.value;
            let unit = 0;
            while (value >= 1024 && unit < units.length - 1) {
                value /= 1024;
                unit += 1;
            }
            return ` · ${value.toFixed(unit === 0 ? 0 : 1)} ${units[unit]}`;
        });
        return (_ctx, _cache) => {
            return (url.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (isImage.value)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: url.value,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            class: _normalizeClass(["block overflow-hidden rounded-lg", __props.isOutgoing ? 'bg-white/10' : 'bg-ewhite-100'])
                        }, [
                            _createElementVNode("img", {
                                src: url.value,
                                alt: fileName.value,
                                class: "max-h-72 w-full max-w-sm object-cover",
                                loading: "lazy"
                            }, null, 8, _hoisted_3)
                        ], 10, _hoisted_2))
                        : (isVideo.value)
                            ? (_openBlock(), _createElementBlock("video", {
                                key: 1,
                                src: url.value,
                                controls: "",
                                preload: "metadata",
                                class: "max-h-72 w-full max-w-sm rounded-lg",
                                "data-test": "message-video-preview"
                            }, null, 8, _hoisted_4))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 2,
                                href: url.value,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                class: _normalizeClass(["flex max-w-sm items-center gap-3 rounded-lg border px-3 py-2 text-xs transition",
                                    __props.isOutgoing
                                        ? 'border-white/20 bg-white/10 text-white hover:bg-white/15'
                                        : 'border-ewhite-200 bg-ewhite-50 text-eblack-700 hover:bg-ewhite-100'
                                ]),
                                "data-test": "message-document-preview"
                            }, [
                                _createElementVNode("span", {
                                    class: _normalizeClass(["flex h-9 w-9 flex-none items-center justify-center rounded-lg", __props.isOutgoing ? 'bg-white/15' : 'bg-white'])
                                }, [
                                    (isPdf.value)
                                        ? (_openBlock(), _createBlock(_unref(IconFileTypePdf), {
                                            key: 0,
                                            class: "h-5 w-5"
                                        }))
                                        : (_openBlock(), _createBlock(_unref(IconFileText), {
                                            key: 1,
                                            class: "h-5 w-5"
                                        }))
                                ], 2),
                                _createElementVNode("span", _hoisted_6, [
                                    _createElementVNode("span", _hoisted_7, _toDisplayString(fileName.value), 1),
                                    _createElementVNode("span", _hoisted_8, _toDisplayString(typeLabel.value) + _toDisplayString(sizeLabel.value), 1)
                                ]),
                                _createVNode(_unref(IconExternalLink), { class: "h-4 w-4 flex-none opacity-75" })
                            ], 10, _hoisted_5))
                ]))
                : _createCommentVNode("", true);
        };
    }
});
